import { finish, error } from '../../../modules/bets/actions/cancel-bet';
import api from '../../../api';

export function request(dispatch, { id, accountId }) {
    api.post('/bets/' + id + '/cancel', { accountId }).then(
        (data) => dispatch(finish(id, data)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
